export { default } from "./DealDetails";
